<template>
  <div class="d-flex flex-wrap">
    <v-chip
      v-for="(cobertura, index) in coberturas"
      :key="index"
      small
      class="ma-1"
      :color="map[cobertura].color"
      text-color="white"
      label
    >
      <v-icon left small>
        {{ map[cobertura].icon }}
      </v-icon>
      {{ map[cobertura].text }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'CoberturasChips',
  props: {
    value: {
      type: [Array, String],
      required: true
    }
  },
  computed: {
    coberturas () {
      if (Array.isArray(this.value)) {
        return this.value
      }
      return this.value
        ?.split(',')
        ?.map(v => v.trim())
        ?.filter(v => v)
    },
    map () {
      return {
        u: { text: 'Urgencias', color: 'red darken-2', icon: 'mdi-hospital' },
        c: { text: 'Consultas', color: 'blue darken-2', icon: 'mdi-stethoscope' },
        d: { text: 'Dental', color: 'green darken-2', icon: 'mdi-tooth' },
        v: { text: 'Visual', color: 'purple darken-2', icon: 'mdi-eye' },
        e: { text: 'Estudios', color: 'blue darken-2', icon: 'mdi-eye' }
      }
    }
  }
}
</script>
